
import React, { useEffect, useState, useContext } from 'react'
import { Link, NavLink } from 'react-router-dom';
import { AuthContext } from '../../auth/authContext';
import M from 'materialize-css';
import Swal from 'sweetalert2';
import { createDevolution, editDevolution, getOneDevolution, getDevolutions } from '../../helpers/conceptosFunc';


export const RegisterDevolution = () => {
    ;
    const { currentUser } = useContext(AuthContext);

    // const [logingCompanies, setLoadingCompanies] = useState(true);
    // const [listCompanies, setListCompanies] = useState([]);
    const initialValues = { name: "", nameES: "", description: "" };
    const [formValues, setFormValues] = useState(initialValues);

    useEffect(() => {
        let isMounted = true;
        const select = document.querySelectorAll('select');
        M.FormSelect.init(select);
        return () => {
            isMounted = false;
        };

    }, []);//logingCompanies

    const handleChange = (e) => {
        console.log(e.target.value);
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    }


    const validate = (values) => {
        // e.preventDefault();
        //  console.log('Click enviar');
        let msgError = '';
        let flag;
        const typeStatus = document.getElementById("typeStatus");
        // if (values.company === "" || values.company === "DEFAULT") {
        //     msgError += "La compañia es requerida.\n";
        //     flag = false;
        // }
        if (values.name === "") {
            msgError += "El nombre de la devolución en ingles es requerido.\n";
            flag = false;
        }
        if (values.nameES === "") {
            msgError += "El nombre de la devolución en español es requerido.\n";
            flag = false;
        }
        if (values.description === "") {
            msgError += "La descripción es requerida.\n";
            flag = false;
        }


        if (msgError !== "") {
            msgError = "Todos los campos son requeridos."
            Swal.fire({
                title: 'Aviso',
                text: msgError,
                icon: 'warning',
            });

            flag = false;
        } else {
            flag = true;
        }

        return flag;

    }

    /* const handlerChangeSelector = (e) =>{
         e.preventDefault();
         console.log(e.target.value); // get the value = id firebase user
         selectCompanyState(e.target.value);
     }*/

    const swalMessagepop = (title) => {
        Swal.fire({
            title: 'Advertencia',
            // text: 'No se pudo obtener la información de' + title + ', inténtelo más tarde.',
            text: title, 
            icon: 'warning',
            confirmButtonText: 'Ok',
        });
    }

    const handlerSaveEdit = async (e) => {
        e.preventDefault();

        // Validamos si hay internet.
        // await getDevolutions(currentUser.idCompany, "").then((result) => {});
        const estaEnLinea = navigator.onLine;
        if (!estaEnLinea) {
            swalMessagepop('Se ha perdido la conexión');
        } else {
        //

        const flag = validate(formValues);

        if (flag === true) {
            const data = {
                name: formValues.name.toUpperCase(),
                nameES: formValues.nameES.toUpperCase(),
                description: formValues.description,
            }


            const result = await createDevolution(data, currentUser.idCompany);
            if (result === 1) {
                Swal.fire({
                    title: 'Exitoso',
                    text: 'Devolución creada.',
                    confirmButtonText: 'Ok',
                    icon: 'success',
                });

                setFormValues(initialValues);

            } else if (result === 0) {
                
                Swal.fire({
                    title: 'Aviso',
                    text: 'No se pudo crear la devolución.',
                    confirmButtonText: 'Ok',
                    icon: 'warning',
                });

                setFormValues(initialValues);

            }
        }
        //saveRegisterStatusByCompany
        }
    }







    return (

        // <>

        //     {currentUser.typeUser === 1 ? 
        <> <div className='containerUser'>
            <div className='contentForm' style={{ paddingTop: '300px' }}>
                <div className='col s12 m12 l12 center'>
                    <div className=' center'><h4>Registro de causas de devolución</h4></div>
                    <div className='grettingsDiv'>

                    </div>
                    <form className='col s12 m12 l12'>
                        <div className='row'>

                            {/* <div className="input-field white lighten-5 inputRegisterUser spaceBottom20">
                                <i className="tiny material-icons prefix iconPositionInput "></i>
                                <select name="company"

                                    onChange={handleChange} required
                                    defaultValue={'DEFAULT'}
                                >
                                    <option key='0' value='DEFAULT' disabled>Select company</option>

                                    {

                                        listCompanies.map((company) => {
                                            //console.log(user);
                                            return <option key={company.id} value={company.idCompany}>{company.name}</option>
                                        })

                                    }
                                </select>

                            </div> */}

                            <div className="input-field  white lighten-5 inputRegisterUser spaceBottom20">

                                <input name="name" placeholder="nombre en ingles" type="text" required id='name'
                                    value={formValues.name} onChange={handleChange} maxlength="50" />
                            </div>

                            <div className="input-field  white lighten-5 inputRegisterUser spaceBottom20">

                                <input name="nameES" placeholder="nombre en español" type="text" required id='nameES'
                                    value={formValues.nameES} onChange={handleChange} maxlength="50" />
                            </div>


                            <div className="input-field  white lighten-5 inputRegisterUser spaceBottom20">

                                <input name="description" placeholder="código: ej -> TAL04" type="text" className="" required id='description'
                                    value={formValues.description} onChange={handleChange} maxlength="10" />
                            </div>

                        </div>
                        <div className='registerDiv'>
                            <button
                                className='btn waves-effect waves-light btnFromRegisterCreate'
                                onClick={handlerSaveEdit}
                                type='button' name='Crear'>
                                Crear
                            </button>
                            <Link to='/conceptosDevolucion' className='btn btnFromLogin' id='btnFromLoginRU' style={{ background: '#5E5E68', width: '100px !important' }}>Salir</Link>
                        </div>
                    </form>

                </div>

            </div>
        </div></>
        // : <>
        //     <div><div className='containerUser'>
        //         <h3 className='center'>No tiene acceso a este apartado.</h3>
        //     </div>
        //     </div></>}

        // </>


    )
}
